import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'Understand how medicines are made under GMP, from the warehouse to batch release. 6 professional volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-white font-sans text-gray-600 antialiased" data-id="element-0" data-mp="nwc23tmizxws">
      <MetaPixel data-id="element-1" data-mp="studdqo0mp7y" />
      <main data-id="element-2" data-mp="stc6m03q8sls">
        <Hero data-id="element-3" data-mp="sssq8ntq6c9v" />
        <LookInsideCarousel data-id="element-4" data-mp="swq9d9gaz3tr" />
        <ProblemSection data-id="element-5" data-mp="3688rpx40wyp" />
        <SystemSection data-id="element-6" data-mp="35gnb7x88fm5" />
        <ModulesSection data-id="element-7" data-mp="34nb3rfi0xwm" />
        <BonusSection data-id="element-8" data-mp="38b2ol1dva8p" />
        <UrgencySection data-id="element-9" data-mp="3uday0bte0t6a" />
        <PricingSection data-id="element-10" data-mp="3ubzso7kandd2" />
        <GuaranteeSection data-id="element-11" data-mp="3ucj91juaptoz" />
        <FAQ data-id="element-12" data-mp="d4nuteha5g1c" />
        <ClosingSection data-id="element-13" data-mp="d57h17dyqql6" />
        <SummaryTable data-id="element-14" data-mp="d3cu5nj4soeg" />
        <FinalCta data-id="element-15" data-mp="d3wc348s7csh" />
      </main>
      <Footer data-id="element-16" data-mp="85l0anyxes7m" />
      <PurchaseNotification data-id="element-17" data-mp="851m9icecnyv" />
    </div>;
}